var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),(_vm.snackbar)?_c('success-snackbar',{attrs:{"open":_vm.open,"title":_vm.snackbar.title,"message":_vm.snackbar.message,"type":_vm.snackbar.type}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }